import { gql } from '@apollo/client';
import {
  GetFocusPointQuery,
  GetFocusPointQueryVariables,
  GetResolvedImageQuery,
  GetResolvedImageQueryVariables,
  GetUploadUrlQuery,
  GetUploadUrlQueryVariables,
} from '__generated__/queries-image';
import { useQueryPromise } from 'utils/useQueryPromise';

export const GET_UPLOAD_URL = gql`
  query GetUploadUrl($namespace: String!, $originalName: String!) {
    getUploadUrl(namespace: $namespace, originalName: $originalName) {
      uploadURL
      key
      id
    }
  }
`;

export const useUploadUrlGetter = () =>
  useQueryPromise<GetUploadUrlQuery, GetUploadUrlQueryVariables>(
    GET_UPLOAD_URL,
  );

export const GET_RESOLVED_IMAGE = gql`
  query GetResolvedImage($key: String!) {
    getResolvedImage(key: $key) {
      url
    }
  }
`;

export const useResolvedImageGetter = () =>
  useQueryPromise<GetResolvedImageQuery, GetResolvedImageQueryVariables>(
    GET_RESOLVED_IMAGE,
  );

export const GET_FOCUS_POINT = gql`
  query GetFocusPoint(
    $imageUrl: String!
    $imageWidth: Int!
    $imageHeight: Int!
  ) {
    getFocusPoint(
      imageUrl: $imageUrl
      imageWidth: $imageWidth
      imageHeight: $imageHeight
    ) {
      relativeX
      relativeY
      x
      y
    }
  }
`;

export const useFocusPointGetter = () =>
  useQueryPromise<GetFocusPointQuery, GetFocusPointQueryVariables>(
    GET_FOCUS_POINT,
  );
